<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <template v-if="pdGoods.length != 0">
        <v-carousel v-model="model" height="55%" hide-delimiter-background hide-delimiters :continuous="true"
                    :show-arrows="false">
          <v-carousel-item height="100%" v-for="(item, index) in imgs" :key="index">
            <v-sheet
                height="100%"
                :style="{'background-image':'url(' + $downUrl(item) + ')', 'background-size' :'80%', 'background-position':'center'}"
                class="sheet"
            >
            </v-sheet>
          </v-carousel-item>

          <div class="pagination" style="text-align: center;">{{ model + 1 }} / {{ imgs.length }}</div>
        </v-carousel>
        <v-container flex-fill fluid>
          <div class="title-area">
            <div class="fs-18 lightBlack--text mb-2" v-text="pdGoods.goodsNm"></div>
            <span class="fs-16 fw-700">{{ (pdGoods.saleAmt - pdGoods.dcAmt) + 'C' }}</span>
          </div>
          <div class="pa-5 fs-16" v-text="pdGoods.goodsDscrt">
          </div>
        </v-container>
      </template>
    </v-layout>
    <v-footer color="transparent" fixed class="content-footer">
      <div class="footer-btns">
        <BlackBtn x-large str="교환하기" @click="moveGoodsDetail" :disabled="isSale"/>
      </div>
    </v-footer>
  </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import {Pagination} from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import store from '@/store'
import moment from "moment";

moment.locale("ko");
export default {
  data: () => ({
    plugins: [new Pagination({type: 'fraction'})],
    flickingOptions: {
      align: 'prev',
      moveType: 'freeScroll',
      circularFallback: "bound",
      circular: false,
      bound: true
    },
    goodsNo: null,
    pdGoods: {
      atchImgs: [],
      saleAmt: ''
    },
    imgs: [],
    isSale: false,
    model: 0

  }),
  components: {
    BlackBtn,
  },
  async mounted() {
    if (this.$route.query.goodsNo != undefined) {
      this.goodsNo = this.$route.query.goodsNo
      this.exchangeGoodsDetail()
    } else {
      this.goodsNo = this.$route.params.goodsNo
    }
  },
  methods: {
    async exchangeGoodsDetail() {
      await store.dispatch('exchangeGoodsDetail', this.$_payload({goodsNo: this.goodsNo}))
        .then(res => {
          this.amountCoin = res.data.amountCoin;
          this.pdGoods = res.data.pdGoods;

          if (this.pdGoods.atchNoList != null) {
            this.imgs = this.pdGoods.atchFileNameLists;
          }
          if ((this.pdGoods.cntLimit !== 0 && this.pdGoods.cntLimit === this.pdGoods.saleCnt)
            || (this.amountCoin < this.pdGoods.saleAmt)) {

            this.isSale = true
          }
        })
        .catch(error => {
          console.error(error)

        })
        .finally(() => {

        })
    },
    async moveGoodsDetail() {
      await store.dispatch('exchangeGoodsDetail', this.$_payload({goodsNo: this.goodsNo}))
        .then(res => {
          this.amountCoin = res.data.amountCoin;
          this.pdGoods = res.data.pdGoods;
          if (this.pdGoods.cntLimit !== 0 && this.pdGoods.cntLimit === this.pdGoods.saleCnt) {
            this.isSale = true
            this.$alert("상품 재고가 없습니다.")
          } else {
            this.$router.push(`/fo/purchase?goodsNo=${this.pdGoods.goodsNo}`)
          }
        })
        .catch(error => {
          console.error(error)

        })
        .finally(() => {

        })

    }
  }
}
</script>
<style lang="scss" scoped>
.items {
  height: 45vh;
}

.title-area {
  padding: 20px;
  border-bottom: 1px solid #F2F2F2;
}

::v-deep.content-header {
  background-color: transparent !important;

  .v-toolbar__content {
    background-color: transparent !important;
  }
}

.flicking-pagination {
  color: #fff;
  text-shadow: 0 3px 4px rgba(0, 0, 0, 0.16);
}

::v-deep.v-carousel {
  .v-window__container {
    height: 100% !important;
  }

  .v-image {
    height: 100% !important;
  }
}
</style>
